import { render, staticRenderFns } from "./OperaCompanyWindow.vue?vue&type=template&id=3385388a&scoped=true&"
import script from "./OperaCompanyWindow.vue?vue&type=script&lang=js&"
export * from "./OperaCompanyWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaCompanyWindow.vue?vue&type=style&index=0&id=3385388a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3385388a",
  null
  
)

export default component.exports